/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react'
import { createReducerCtx } from '../../utils/react-utils'

// Declare Types
type ListObjShape = {
    id: string | number
    state: string | number
    [extraAttr: string]: any
}
type StateShape = {
    listChecked: ListObjShape[] | []
    allChecked: boolean
}
type ActionShape =
    | {
          type: 'ADD_ITEM_CHECKED'
          payload: ListObjShape
      }
    | {
          type: 'REMOVE_ITEM_CHECKED'
          payload: {
              id: string | number
              idName: string
          }
      }
    | {
          type: 'ALL_ITEM_CHECKED'
          payload: {
              isChecked: boolean
              itemsChecked: ListObjShape[] | []
          }
      }

// Initial define
const initialState: StateShape = {
    listChecked: [],
    allChecked: false
}

const reducer = (state: StateShape, action: ActionShape): StateShape => {
    switch (action.type) {
        case 'ADD_ITEM_CHECKED':
            return { ...state, listChecked: [...state.listChecked, action.payload] }
        case 'REMOVE_ITEM_CHECKED':
            return {
                ...state,
                listChecked: state.listChecked.filter(
                    item => item[action.payload.idName] !== action.payload.id
                )
            }
        case 'ALL_ITEM_CHECKED':
            return {
                ...state,
                allChecked: action.payload.isChecked,
                listChecked: action.payload.itemsChecked
            }
        default:
            return state
    }
}

const [ctx, CheckListProvider] = createReducerCtx<StateShape, ActionShape>(reducer, initialState)

export const CheckListContext = ctx
export default CheckListProvider
